import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { BsBookmarkHeartFill } from 'react-icons/bs';
import { HiViewGrid, HiLocationMarker, HiFlag } from 'react-icons/hi';

import Price from '@/tayara-kit/Price';
import Text from '@/tayara-kit/Text';
import VerticalIconButton from '@/tayara-kit/VerticalIconButton';

import { IAdDetailItem } from '../../types';

dayjs.extend(relativeTime);

type DetailsProps = {
  adDetails: IAdDetailItem;
};

const ItemHeader = ({ adDetails }: DetailsProps) => {
  const iqosId = adDetails.publisher.id;

  return (
    <div>
      <Text
        as="h1"
        text={adDetails.title}
        dir="auto"
        className="text-gray-700 font-bold text-2xl font-arabic"
      />
      {/* Pricing */}
      <div className="mt-4">
        <Price price={adDetails.price} className="text-2xl" />
      </div>

      {/* Toolbar */}
      <div className="flex justify-between items-center mt-5 mb-8">
        {/* Category and datetime Metadata */}
        <span className={`text-sm font-light text-gray-700`}>
          <div className="flex items-center space-x-2">
            <HiViewGrid className="mt-1" size={16} />
            <Text text={adDetails.category} />
          </div>
          <div className="flex items-center space-x-2 mb-1">
            <HiLocationMarker className="mt-1" size={16} />
            {iqosId !== '642fd5cc39b6f183fc7fcbbc' ? (
              <Text
                text={`${adDetails.location?.governorate} , ${dayjs(
                  adDetails?.publishedOn
                ).fromNow()}`}
              />
            ) : (
              <Text
                text={`Toute la Tunisie, ${dayjs(
                  adDetails?.publishedOn
                ).fromNow()}`}
              />
            )}
          </div>
        </span>

        {/* Key vertical button */}
        <ul className="gap-x-6">
          <li className="hidden">
            <VerticalIconButton
              icon={BsBookmarkHeartFill}
              label="Entregitrer"
              colorClassName="text-gray-600 group-hover:bg-gray-200"
            />
          </li>
          {/* <li>
          <VerticalIconButton
            icon={FaShare}
            label="Partager"
            colorClassName="text-gray-600 group-hover:bg-gray-200"
          />
        </li> */}
          <li className="hidden">
            <VerticalIconButton
              icon={HiFlag}
              label="Signaler"
              colorClassName="text-gray-600 group-hover:bg-gray-200"
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ItemHeader;
